export default __webpack_public_path__ + "static/media/google-maps-icon.svg.393af096.png";